var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworkInsightsErrorGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 889.21 662.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a73d24;}.cls-2{fill:#707b87;}.cls-3{fill:#243444;}.cls-4{fill:#252a2e;}.cls-5{fill:#fff;}.cls-6{clip-path:url(#clippath-2);}.cls-7{clip-path:url(#clippath-1);}.cls-8{fill:#979ea9;}.cls-9{clip-path:url(#clippath);}.cls-10{fill:none;}.cls-11{fill:#0063a1;}.cls-12{fill:#edeef1;}.cls-13{fill:#e0e1e5;}.cls-14{fill:#b5dbf0;}.cls-15{fill:#f9ab26;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 177.13,
    y: 450.53,
    width: 46.19,
    height: 194.22,
    transform: "translate(747.87 347.41) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "421.49 584.25 448.86 638.98 394.13 638.98 421.49 584.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "577.45 584.25 604.82 638.98 550.08 638.98 577.45 584.25"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M243.64,295.96l.05-.08c-.26-.5-.56-.98-.89-1.44-2.34-3.68-6.41-6.14-11.08-6.23,.02-.35,.05-.7,.05-1.05,0-9.5-7.7-17.19-17.19-17.19-6.45,0-12.06,3.56-15.01,8.81-2.64-1.65-5.75-2.62-9.1-2.62-7.97,0-14.66,5.44-16.6,12.8-6.69,.49-11.97,5.99-12.1,12.77h-11.69c-3.68,0-6.66,2.98-6.66,6.66s2.98,6.66,6.66,6.66h81.38c7.41,0,13.42-6.01,13.42-13.42,0-2.02-.46-3.94-1.26-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M644.19,350.8l-.05-.07c.23-.43,.49-.85,.77-1.25,2.03-3.19,5.56-5.33,9.61-5.4-.02-.3-.05-.6-.05-.91,0-8.24,6.68-14.92,14.92-14.92,5.6,0,10.47,3.09,13.02,7.65,2.29-1.43,4.99-2.28,7.89-2.28,6.92,0,12.72,4.72,14.41,11.1,5.8,.42,10.39,5.2,10.5,11.08h10.14c3.19,0,5.77,2.59,5.77,5.77,0,3.19-2.59,5.77-5.77,5.77h-70.61c-6.43,0-11.64-5.21-11.64-11.64,0-1.76,.4-3.42,1.1-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M626.11,99.91c-4.17-15.78-18.5-27.43-35.58-27.43-7.17,0-13.84,2.08-19.5,5.62-6.3-11.26-18.33-18.89-32.16-18.89-20.35,0-36.84,16.5-36.84,36.84,0,.76,.07,1.5,.12,2.25-9.99,.18-18.73,5.46-23.74,13.34-.69,.98-1.33,2.01-1.9,3.08l.12,.18c-1.72,3.69-2.71,7.79-2.71,12.13,0,15.88,12.88,28.76,28.76,28.76h121.39c15.46,0,28-12.53,28-28s-11.45-26.84-25.95-27.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M268.84,115.12c3.34-12.66,14.84-22,28.54-22,5.75,0,11.1,1.67,15.64,4.51,5.06-9.04,14.71-15.15,25.8-15.15,16.32,0,29.55,13.23,29.55,29.55,0,.61-.06,1.21-.09,1.81,8.02,.15,15.02,4.38,19.04,10.7,.56,.79,1.07,1.61,1.52,2.47l-.09,.15c1.38,2.96,2.17,6.25,2.17,9.73,0,12.74-10.33,23.07-23.07,23.07h-97.37c-12.4,0-22.46-10.05-22.46-22.46,0-11.85,9.18-21.53,20.81-22.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M856.45,542.25h-69.31c-16.12-2.04-28.6-15.8-28.6-32.48,0-18.09,14.66-32.75,32.75-32.75h27.71c18.09,0,32.75-14.66,32.75-32.75h0c0-18.09-14.66-32.75-32.75-32.75h-115.18c-18.09,0-32.75-14.66-32.75-32.75h0c0-17.34,13.48-31.53,30.53-32.67h19.66c18.09,0,32.75-14.66,32.75-32.75s-14.66-32.75-32.75-32.75h-54.12c-18.09,0-32.75-14.66-32.75-32.75s14.66-32.75,32.75-32.75h2.14c18.09,0,32.75-14.66,32.75-32.75h0c0-18.09-14.66-32.75-32.75-32.75H199.33c-18.09,0-32.75,14.66-32.75,32.75h0c0,18.09,14.66,32.75,32.75,32.75h8.97c-.77,0-1.52,.04-2.27,.09,17.03,1.17,30.48,15.34,30.48,32.66s-13.45,31.5-30.48,32.66c.75,.05,1.51,.09,2.28,.09h-45.55c-18.09,0-32.75,14.66-32.75,32.75s14.66,32.75,32.75,32.75h3.66c17.05,1.14,30.53,15.33,30.53,32.67h0c0,18.09-14.66,32.75-32.75,32.75h-61.1c-18.09,0-32.75,14.66-32.75,32.75h0c0,18.09,14.66,32.75,32.75,32.75h38.3c18.09,0,32.75,14.66,32.75,32.75,0,16.68-12.47,30.44-28.6,32.48H70.62c-.38-.05-.77-.08-1.15-.14v.14h-28.17c-18.09,0-32.75,14.66-32.75,32.75s14.66,32.75,32.75,32.75H856.45c18.09,0,32.75-14.66,32.75-32.75s-14.66-32.75-32.75-32.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 469.38,
    y: 436.92,
    width: 12.63,
    height: 145.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M482.01,583.77h-12.63c-.55,0-1-.45-1-1v-145.85c0-.55,.45-1,1-1h12.63c.55,0,1,.45,1,1v145.85c0,.55-.45,1-1,1Zm-11.63-2h10.63v-143.85h-10.63v143.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "482.01 461.99 469.39 461.99 463.31 429.07 488.09 429.07 482.01 461.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M482.01,462.99h-12.62c-.48,0-.9-.34-.98-.82l-6.09-32.92c-.05-.29,.02-.59,.21-.82s.47-.36,.77-.36h24.78c.3,0,.58,.13,.77,.36,.19,.23,.27,.53,.21,.82l-6.08,32.92c-.09,.47-.5,.82-.98,.82Zm-11.79-2h10.95l5.71-30.92h-22.38l5.72,30.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 402.79,
    y: 436.92,
    width: 12.63,
    height: 145.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M415.42,583.77h-12.63c-.55,0-1-.45-1-1v-145.85c0-.55,.45-1,1-1h12.63c.55,0,1,.45,1,1v145.85c0,.55-.45,1-1,1Zm-11.63-2h10.63v-143.85h-10.63v143.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "415.42 461.99 402.8 461.99 396.71 429.07 421.49 429.07 415.42 461.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M415.42,463.99h-12.62c-.96,0-1.79-.69-1.97-1.64l-6.09-32.92c-.11-.58,.05-1.19,.43-1.64,.38-.46,.94-.72,1.54-.72h24.78c.59,0,1.16,.26,1.54,.72s.54,1.06,.43,1.64l-6.08,32.92c-.18,.95-1,1.64-1.97,1.64Zm-10.95-4h9.29l5.34-28.92h-19.97l5.35,28.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M200.23,617.07h322.61c-110.65-52.92-197.05-127.85-6.15-191.74v-9.96l-117.44,.13v9.84h4.42c-9.52,.05-169.56,3.75-203.44,191.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M522.84,619.07H200.23c-.59,0-1.15-.26-1.53-.72-.38-.45-.54-1.05-.43-1.64,7.8-43.3,22.98-80.35,45.1-110.1,17.88-24.05,40.35-43.45,66.77-57.65,37.31-20.06,72.66-24.43,87.11-25.37v-8.09c0-1.1,.89-2,2-2l117.44-.13h0c.53,0,1.04,.21,1.41,.58,.38,.38,.59,.88,.59,1.42v9.96c0,.86-.55,1.62-1.37,1.9-71.9,24.07-109.29,51.39-111.13,81.21-1.08,17.51,10.17,36.32,33.45,55.89,19.64,16.52,47.92,33.65,84.06,50.94,.84,.4,1.29,1.34,1.09,2.25-.21,.91-1.02,1.56-1.95,1.56Zm-320.2-4h311.51c-76.34-37.64-113.99-73.58-111.94-106.88,1.94-31.41,39.78-59.78,112.49-84.3v-6.52l-113.44,.12v5.84h2.42c1.1,0,2,.89,2,1.99s-.89,2-1.99,2.01c-4.64,.03-46.63,.95-91.65,25.15-58.26,31.33-95.06,86.02-109.4,162.59Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 543.32,
    y: 272.97,
    width: 9.93,
    height: 336.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M554.25,610.67h-11.93V271.97h11.93v338.7Zm-9.93-2h7.93V273.97h-7.93v334.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 301.04,
    y: 272.97,
    width: 9.93,
    height: 336.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M311.97,610.67h-11.93V271.97h11.93v338.7Zm-9.93-2h7.93V273.97h-7.93v334.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 422.18,
    y: 175.65,
    width: 9.93,
    height: 232.35,
    transform: "translate(718.97 -135.33) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M544.32,297.79h-234.35v-11.93h234.35v11.93Zm-232.35-2h230.35v-7.93h-230.35v7.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 695.19,
    y: 542.22,
    width: 13.67,
    height: 112.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M708.87,656.68h-13.67c-1.1,0-2-.9-2-2v-112.46c0-1.1,.9-2,2-2h13.67c1.1,0,2,.9,2,2v112.46c0,1.1-.9,2-2,2Zm-11.67-4h9.67v-108.46h-9.67v108.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M194,648.61c3.66-235.49,210.12-233.24,210.12-233.24h112.57c-336.73,101.21,189.33,233.24,189.33,233.24H194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M706.02,650.61H194c-.54,0-1.05-.21-1.43-.6s-.58-.9-.57-1.43c.84-54.07,12.5-100.1,34.66-136.79,17.76-29.41,42.26-52.92,72.8-69.85,51.93-28.8,104.14-28.57,104.68-28.56h112.54c.99,0,1.83,.73,1.98,1.71,.14,.98-.45,1.92-1.4,2.21-74.38,22.36-111.77,47.76-111.13,75.52,1.8,78.03,297.39,153.12,300.37,153.87,.98,.25,1.62,1.18,1.5,2.19-.12,1-.98,1.75-1.98,1.75Zm-509.98-4h494.6c-25.68-6.99-80.84-22.82-135.59-43.84-100.68-38.65-152.13-75.62-152.92-109.88-.33-14.38,8.4-28.13,25.97-40.89,16.79-12.2,42.14-23.83,75.47-34.63h-99.44c-.52,0-51.84-.2-102.86,28.14-46.72,25.96-102.75,81.89-105.22,201.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M419.49,645.2c-.17,0-.34-.04-.49-.13-4.74-2.69-9.4-5.41-13.83-8.1-.47-.29-.62-.9-.34-1.37s.9-.62,1.37-.34c4.42,2.67,9.05,5.39,13.78,8.07,.48,.27,.65,.88,.38,1.36-.18,.32-.52,.51-.87,.51Zm-30.69-18.79c-.19,0-.38-.05-.55-.17-4.57-3.05-9-6.13-13.16-9.17-.45-.33-.54-.95-.22-1.4,.32-.45,.95-.54,1.4-.22,4.14,3.02,8.54,6.09,13.09,9.12,.46,.31,.58,.93,.28,1.39-.19,.29-.51,.45-.83,.45Zm-28.88-21.43c-.23,0-.45-.08-.64-.23-4.25-3.56-8.28-7.17-11.96-10.71-.4-.38-.41-1.02-.03-1.41s1.02-.41,1.41-.03c3.65,3.52,7.64,7.09,11.86,10.62,.42,.35,.48,.99,.12,1.41-.2,.24-.48,.36-.77,.36Zm-25.53-25.29c-.29,0-.57-.12-.77-.36-3.57-4.33-6.75-8.72-9.46-13.03-.29-.47-.15-1.08,.31-1.38,.47-.29,1.09-.15,1.38,.31,2.67,4.24,5.8,8.56,9.31,12.82,.35,.43,.29,1.06-.14,1.41-.19,.15-.41,.23-.64,.23Zm-18.19-30.83c-.41,0-.8-.26-.94-.67-1.86-5.26-3.07-10.57-3.62-15.77-.06-.55,.34-1.04,.89-1.1,.55-.05,1.04,.34,1.1,.89,.53,5.05,1.71,10.2,3.52,15.32,.18,.52-.09,1.09-.61,1.28-.11,.04-.22,.06-.33,.06Zm-2.4-35.37c-.07,0-.15,0-.22-.02-.54-.12-.88-.66-.76-1.2,1.15-5.1,2.97-10.22,5.42-15.23,.24-.5,.84-.7,1.34-.46,.5,.24,.7,.84,.46,1.34-2.38,4.87-4.15,9.84-5.26,14.79-.1,.46-.52,.78-.97,.78Zm16.14-31.78c-.22,0-.44-.07-.63-.22-.43-.35-.5-.98-.15-1.41,3.2-3.98,6.87-7.98,10.92-11.87,.4-.38,1.03-.37,1.41,.03,.38,.4,.37,1.03-.03,1.41-3.99,3.83-7.6,7.76-10.75,11.68-.2,.25-.49,.37-.78,.37Zm26.1-24.71c-.3,0-.6-.14-.8-.4-.33-.44-.25-1.07,.2-1.4,4.11-3.1,8.55-6.2,13.2-9.2,.46-.3,1.08-.17,1.38,.3,.3,.46,.17,1.08-.3,1.38-4.61,2.98-9.01,6.05-13.08,9.12-.18,.14-.39,.2-.6,.2Zm30.37-19.38c-.35,0-.7-.19-.88-.52-.27-.48-.09-1.09,.4-1.36,4.6-2.51,9.41-4.98,14.3-7.35,.5-.24,1.1-.03,1.34,.47,.24,.5,.03,1.1-.47,1.34-4.86,2.35-9.65,4.8-14.21,7.3-.15,.08-.32,.12-.48,.12Zm32.56-15.51c-.39,0-.77-.23-.92-.62-.21-.51,.03-1.1,.54-1.31,9.1-3.75,15.05-5.74,15.11-5.76,.53-.17,1.09,.11,1.26,.63,.17,.52-.11,1.09-.63,1.26-.06,.02-5.95,1.98-14.98,5.71-.12,.05-.25,.08-.38,.08Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 373.77,
    y: 216.16,
    width: 107.31,
    height: 128.84,
    rx: 6.04,
    ry: 6.04,
    transform: "translate(708.01 -146.85) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M485.81,335.23h-116.76c-3.88,0-7.04-3.16-7.04-7.04v-95.23c0-3.88,3.16-7.04,7.04-7.04h116.76c3.88,0,7.04,3.16,7.04,7.04v95.23c0,3.88-3.16,7.04-7.04,7.04Zm-116.76-107.31c-2.78,0-5.04,2.26-5.04,5.04v95.23c0,2.78,2.26,5.04,5.04,5.04h116.76c2.78,0,5.04-2.26,5.04-5.04v-95.23c0-2.78-2.26-5.04-5.04-5.04h-116.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M453.74,259.84c-4.58-8.44-13.52-14.17-23.8-14.17h0c-10.28,0-19.22,5.73-23.8,14.17-2.08,3.84-3.27,8.23-3.27,12.9h0v22.5h-5.81c-1.55,0-2.42,1.78-1.47,3l12.86,16.53c.75,.96,2.19,.96,2.94,0l12.86-16.53c.95-1.22,.08-3-1.47-3h-5.87v-22.5h0c0-7.21,5.83-13.05,13.03-13.08,7.2,.03,13.03,5.87,13.03,13.08h0v39.33c0,1.03,.83,1.86,1.86,1.86h10.32c1.03,0,1.86-.83,1.86-1.86v-39.33h0c0-4.67-1.18-9.07-3.27-12.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M252.2,304.53l.05-.08c-.26-.5-.56-.98-.89-1.44-2.34-3.68-6.41-6.14-11.08-6.23,.02-.35,.05-.7,.05-1.05,0-9.5-7.7-17.19-17.19-17.19-6.45,0-12.06,3.56-15.01,8.81-2.64-1.65-5.75-2.62-9.1-2.62-7.97,0-14.66,5.44-16.6,12.8-6.69,.49-11.97,5.99-12.1,12.77h-11.69c-3.68,0-6.66,2.98-6.66,6.66s2.98,6.66,6.66,6.66h81.38c7.41,0,13.42-6.01,13.42-13.42,0-2.02-.46-3.94-1.26-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M240.05,324.6h-81.38c-4.22,0-7.65-3.43-7.65-7.66s3.43-7.65,7.65-7.65h10.74c.57-6.62,5.65-11.89,12.27-12.7,2.33-7.61,9.37-12.87,17.38-12.87,3.06,0,6.06,.78,8.75,2.26,3.33-5.24,9.12-8.45,15.36-8.45,10.03,0,18.19,8.16,18.19,18.19,0,.04,0,.07,0,.11,4.44,.4,8.45,2.83,10.87,6.63,.33,.46,.65,.98,.92,1.5,.08,.14,.11,.3,.12,.46,.8,1.83,1.21,3.77,1.21,5.76,0,7.95-6.47,14.42-14.42,14.42Zm-81.38-13.31c-3.12,0-5.65,2.54-5.65,5.65s2.54,5.66,5.65,5.66h81.38c6.85,0,12.42-5.57,12.42-12.42,0-1.81-.39-3.57-1.17-5.24-.05-.11-.08-.23-.09-.34-.2-.35-.42-.69-.65-1.02-2.27-3.57-6.1-5.73-10.28-5.8-.27,0-.53-.12-.72-.32-.18-.2-.28-.47-.26-.74l.02-.27c.02-.24,.03-.48,.03-.72,0-8.93-7.26-16.19-16.19-16.19-5.85,0-11.27,3.18-14.13,8.3-.13,.24-.36,.41-.62,.48-.26,.07-.55,.02-.78-.12-2.58-1.62-5.55-2.47-8.57-2.47-7.33,0-13.76,4.96-15.64,12.05-.11,.41-.47,.71-.89,.74-6.25,.45-11.05,5.52-11.17,11.79-.01,.54-.46,.98-1,.98h-11.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M637.51,360.56l-.05-.07c.23-.43,.49-.85,.77-1.25,2.03-3.19,5.56-5.33,9.61-5.4-.02-.3-.05-.6-.05-.91,0-8.24,6.68-14.92,14.92-14.92,5.6,0,10.47,3.09,13.02,7.65,2.29-1.43,4.99-2.28,7.89-2.28,6.92,0,12.72,4.72,14.41,11.1,5.8,.42,10.39,5.2,10.5,11.08h10.14c3.19,0,5.77,2.59,5.77,5.77,0,3.19-2.59,5.77-5.77,5.77h-70.61c-6.43,0-11.64-5.21-11.64-11.64,0-1.76,.4-3.42,1.1-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M718.67,378.12h-70.61c-6.97,0-12.64-5.67-12.64-12.64,0-1.73,.35-3.42,1.05-5.02,0-.15,.04-.29,.11-.43,.24-.46,.52-.92,.84-1.36,2.07-3.27,5.54-5.38,9.38-5.76,.01-8.76,7.15-15.89,15.92-15.89,5.41,0,10.45,2.77,13.37,7.29,2.32-1.26,4.91-1.92,7.54-1.92,6.98,0,13.12,4.56,15.18,11.18,5.72,.74,10.11,5.29,10.66,11.01h9.2c3.74,0,6.77,3.04,6.77,6.77s-3.04,6.77-6.77,6.77Zm-80.18-17.42c0,.1-.03,.2-.07,.29-.67,1.43-1,2.94-1,4.49,0,5.87,4.77,10.64,10.64,10.64h70.61c2.63,0,4.77-2.14,4.77-4.77s-2.14-4.77-4.77-4.77h-10.14c-.54,0-.99-.44-1-.98-.1-5.37-4.21-9.71-9.57-10.1-.43-.03-.79-.33-.89-.74-1.61-6.1-7.14-10.36-13.44-10.36-2.6,0-5.14,.73-7.36,2.12-.23,.15-.51,.19-.78,.12-.27-.07-.49-.24-.62-.48-2.46-4.4-7.12-7.14-12.15-7.14-7.67,0-13.92,6.24-13.92,13.92,0,.21,.02,.42,.03,.62l.02,.23c.02,.27-.08,.54-.26,.74-.19,.2-.44,.32-.72,.32-3.58,.06-6.86,1.91-8.79,4.94-.22,.32-.42,.62-.59,.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 634.4,
    cy: 324.17,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M634.4,334.28c-5.58,0-10.12-4.54-10.12-10.12s4.54-10.12,10.12-10.12,10.12,4.54,10.12,10.12-4.54,10.12-10.12,10.12Zm0-18.23c-4.47,0-8.12,3.64-8.12,8.12s3.64,8.12,8.12,8.12,8.12-3.64,8.12-8.12-3.64-8.12-8.12-8.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 244.9,
    cy: 361.8,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.9,371.92c-5.58,0-10.12-4.54-10.12-10.12s4.54-10.12,10.12-10.12,10.12,4.54,10.12,10.12-4.54,10.12-10.12,10.12Zm0-18.23c-4.48,0-8.12,3.64-8.12,8.12s3.64,8.12,8.12,8.12,8.12-3.64,8.12-8.12-3.64-8.12-8.12-8.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 132.37,
    y: 555.69,
    width: 14.07,
    height: 92.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.43,650.61h-14.07c-1.1,0-2-.9-2-2v-92.91c0-1.1,.9-2,2-2h14.07c1.1,0,2,.9,2,2v92.91c0,1.1-.9,2-2,2Zm-12.07-4h10.07v-88.91h-10.07v88.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 254.03,
    y: 555.69,
    width: 14.07,
    height: 92.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.1,650.61h-14.07c-1.1,0-2-.9-2-2v-92.91c0-1.1,.9-2,2-2h14.07c1.1,0,2,.9,2,2v92.91c0,1.1-.9,2-2,2Zm-12.07-4h10.07v-88.91h-10.07v88.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: -12.66,
    y: 431.37,
    width: 236.18,
    height: 16.06,
    transform: "translate(490.68 675.54) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.61,529.32c-.19,0-.38-.07-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53L28.14,529.1c-.15,.15-.34,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29L17.31,517.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -1.3,
    y: 442.72,
    width: 236.18,
    height: 16.06,
    transform: "translate(518.09 686.9) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.96,540.68c-.19,0-.38-.07-.53-.22l-11.35-11.35c-.14-.14-.22-.33-.22-.53s.08-.39,.22-.53l167-167c.29-.29,.77-.29,1.06,0l11.35,11.35c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53L39.49,540.46c-.15,.15-.34,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29L28.67,528.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 10.05,
    y: 454.07,
    width: 236.18,
    height: 16.06,
    transform: "translate(545.5 698.25) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.31,552.03c-.2,0-.39-.08-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.29,.29,.29,.77,0,1.06L50.84,551.81c-.14,.14-.33,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29L40.02,539.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 21.4,
    y: 465.43,
    width: 236.18,
    height: 16.06,
    transform: "translate(572.91 709.6) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.67,563.38c-.2,0-.39-.08-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.29,.29,.29,.77,0,1.06L62.2,563.16c-.14,.14-.33,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29L51.37,551.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 32.76,
    y: 476.78,
    width: 236.18,
    height: 16.06,
    transform: "translate(600.32 720.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.02,574.74c-.19,0-.38-.07-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53l-167,167c-.15,.15-.34,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29L62.73,562.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 44.11,
    y: 488.13,
    width: 236.18,
    height: 16.06,
    transform: "translate(627.73 732.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.37,586.09c-.19,0-.38-.07-.53-.22l-11.35-11.35c-.14-.14-.22-.33-.22-.53s.08-.39,.22-.53l167-167c.29-.29,.77-.29,1.06,0l11.35,11.35c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53l-167,167c-.15,.15-.34,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 55.46,
    y: 499.49,
    width: 236.18,
    height: 16.06,
    transform: "translate(655.14 743.66) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.73,597.44c-.2,0-.39-.08-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.29,.29,.29,.77,0,1.06l-167,167c-.14,.14-.33,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 66.82,
    y: 510.84,
    width: 236.18,
    height: 16.06,
    transform: "translate(682.55 755.02) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.08,608.8c-.2,0-.39-.08-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.29,.29,.29,.77,0,1.06l-167,167c-.14,.14-.33,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 78.17,
    y: 522.19,
    width: 236.18,
    height: 16.06,
    transform: "translate(709.96 766.37) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.43,620.15c-.19,0-.38-.07-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53l-167,167c-.15,.15-.34,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 89.52,
    y: 533.55,
    width: 236.18,
    height: 16.06,
    transform: "translate(737.37 777.72) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.79,631.5c-.19,0-.38-.07-.53-.22l-11.35-11.35c-.14-.14-.22-.33-.22-.53s.08-.39,.22-.53l167-167c.29-.29,.77-.29,1.06,0l11.35,11.35c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53l-167,167c-.15,.15-.34,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 100.88,
    y: 544.9,
    width: 236.18,
    height: 16.06,
    transform: "translate(764.78 789.08) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.14,642.86c-.19,0-.38-.07-.53-.22l-11.35-11.35c-.14-.14-.22-.33-.22-.53s.08-.39,.22-.53l167-167c.29-.29,.77-.29,1.06,0l11.35,11.35c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53l-167,167c-.15,.15-.34,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 112.23,
    y: 556.25,
    width: 236.18,
    height: 16.06,
    transform: "translate(792.19 800.43) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.49,654.21c-.2,0-.39-.08-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.29,.29,.29,.77,0,1.06l-167,167c-.14,.14-.33,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 123.58,
    y: 567.61,
    width: 236.18,
    height: 16.06,
    transform: "translate(819.6 811.78) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.85,665.56c-.2,0-.39-.08-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.29,.29,.29,.77,0,1.06l-167,167c-.14,.14-.33,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 134.94,
    y: 578.96,
    width: 236.18,
    height: 16.06,
    transform: "translate(847 823.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.2,676.92c-.19,0-.38-.07-.53-.22l-11.35-11.35c-.14-.14-.22-.33-.22-.53s.08-.39,.22-.53l167-167c.29-.29,.77-.29,1.06,0l11.35,11.35c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53l-167,167c-.15,.15-.34,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 146.29,
    y: 590.31,
    width: 236.18,
    height: 16.06,
    transform: "translate(874.41 834.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.55,688.27c-.19,0-.38-.07-.53-.22l-11.35-11.35c-.14-.14-.22-.33-.22-.53s.08-.39,.22-.53l167-167c.29-.29,.77-.29,1.06,0l11.35,11.35c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53l-167,167c-.15,.15-.34,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 157.64,
    y: 601.67,
    width: 236.18,
    height: 16.06,
    transform: "translate(901.82 845.84) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.91,699.62c-.2,0-.39-.08-.53-.22l-11.35-11.35c-.29-.29-.29-.77,0-1.06l167-167c.28-.28,.78-.28,1.06,0l11.35,11.35c.29,.29,.29,.77,0,1.06l-167,167c-.14,.14-.33,.22-.53,.22Zm-10.29-12.1l10.29,10.29,165.94-165.94-10.29-10.29-165.94,165.94Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299.34,572.74H101.12v-50.19h198.22v50.19Zm-194.22-4h190.22v-42.19H105.12v42.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 139.4,
    cy: 515.45,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.4,526.56c-6.13,0-11.12-4.99-11.12-11.12s4.99-11.12,11.12-11.12,11.12,4.99,11.12,11.12-4.99,11.12-11.12,11.12Zm0-18.23c-3.92,0-7.12,3.19-7.12,7.12s3.19,7.12,7.12,7.12,7.12-3.19,7.12-7.12-3.19-7.12-7.12-7.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 261.06,
    cy: 515.45,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M261.06,526.56c-6.13,0-11.12-4.99-11.12-11.12s4.99-11.12,11.12-11.12,11.12,4.99,11.12,11.12-4.99,11.12-11.12,11.12Zm0-18.23c-3.92,0-7.12,3.19-7.12,7.12s3.19,7.12,7.12,7.12,7.12-3.19,7.12-7.12-3.19-7.12-7.12-7.12Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2,
    y: 648.61,
    width: 870.87,
    height: 12.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M874.87,662.76H0v-16.15H874.87v16.15ZM4,658.76H870.87v-8.15H4v8.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.45,165.4c-.15,0-.29-.06-.39-.18-1.26-1.55-2.5-3.16-3.66-4.79-.16-.22-.11-.54,.11-.7,.22-.16,.54-.11,.7,.11,1.16,1.61,2.38,3.2,3.63,4.74,.17,.21,.14,.53-.07,.7-.09,.08-.2,.11-.31,.11Zm-5.91-8.06c-.16,0-.32-.08-.42-.22-1.1-1.67-2.17-3.4-3.17-5.13-.14-.24-.06-.54,.18-.68,.24-.14,.54-.06,.68,.18,.99,1.71,2.05,3.42,3.14,5.08,.15,.23,.09,.54-.14,.69-.08,.06-.18,.08-.27,.08Zm-5.09-8.6c-.18,0-.35-.1-.44-.27-.93-1.77-1.82-3.59-2.64-5.42-.11-.25,0-.55,.25-.66,.25-.12,.55,0,.66,.25,.81,1.81,1.7,3.61,2.62,5.36,.13,.24,.03,.55-.21,.67-.07,.04-.15,.06-.23,.06Zm-4.2-9.07c-.2,0-.38-.12-.46-.31-.75-1.85-1.45-3.76-2.09-5.65-.09-.26,.05-.55,.31-.63,.26-.09,.55,.05,.63,.31,.63,1.88,1.33,3.76,2.07,5.6,.1,.26-.02,.55-.28,.65-.06,.02-.12,.04-.19,.04Zm187.33-.9c-.06,0-.12-.01-.18-.04-.26-.1-.38-.39-.28-.65,.42-1.07,.83-2.16,1.22-3.25,.09-.26,.38-.4,.64-.3,.26,.09,.4,.38,.3,.64-.39,1.1-.8,2.2-1.23,3.28-.08,.2-.27,.32-.46,.32Zm2.49-7.06s-.1,0-.15-.02c-.26-.08-.41-.36-.33-.63,.59-1.89,1.13-3.83,1.6-5.75,.07-.27,.34-.43,.6-.37,.27,.07,.43,.34,.37,.6-.48,1.94-1.02,3.9-1.62,5.81-.07,.21-.26,.35-.48,.35Zm-193.09-1.48c-.22,0-.42-.14-.48-.36-.56-1.92-1.07-3.88-1.52-5.83-.06-.27,.11-.54,.38-.6,.27-.06,.54,.11,.6,.38,.44,1.93,.95,3.88,1.5,5.77,.08,.26-.07,.54-.34,.62-.05,.01-.09,.02-.14,.02Zm195.58-8.2s-.07,0-.1-.01c-.27-.06-.44-.32-.39-.59,.4-1.94,.74-3.92,1.02-5.88,.04-.27,.29-.46,.57-.42,.27,.04,.46,.29,.42,.57-.28,1.98-.63,3.98-1.03,5.94-.05,.24-.26,.4-.49,.4Zm-197.91-1.51c-.24,0-.45-.17-.49-.41-.37-1.96-.68-3.96-.94-5.95-.03-.27,.16-.52,.43-.56,.27-.03,.52,.16,.56,.43,.25,1.97,.56,3.95,.93,5.89,.05,.27-.13,.53-.4,.58-.03,0-.06,0-.09,0Zm199.41-8.37s-.03,0-.05,0c-.27-.03-.47-.27-.45-.55,.2-1.97,.34-3.97,.43-5.95,.01-.28,.25-.5,.52-.48,.28,.01,.49,.24,.48,.52-.08,2-.23,4.02-.43,6.01-.03,.26-.24,.45-.5,.45Zm-200.77-1.53c-.26,0-.47-.2-.5-.46-.18-2-.29-4.02-.35-6.02,0-.28,.21-.51,.49-.51,.28,0,.51,.21,.51,.49,.06,1.98,.17,3.98,.35,5.96,.02,.28-.18,.52-.45,.54-.02,0-.03,0-.04,0Zm201.29-8.45c-.28,0-.5-.22-.5-.5v-.21c0-1.91-.06-3.85-.16-5.76-.02-.28,.19-.51,.47-.53,.26-.01,.51,.19,.53,.47,.11,1.93,.17,3.89,.17,5.82v.21c0,.28-.22,.5-.5,.5Zm-201.68-1.54h0c-.28,0-.5-.23-.49-.51,.02-2,.1-4.03,.24-6.02,.02-.28,.25-.48,.53-.46,.28,.02,.48,.26,.46,.53-.14,1.98-.22,3.98-.24,5.96,0,.27-.23,.49-.5,.49Zm201.2-8.45c-.25,0-.47-.19-.5-.45-.07-.69-.14-1.39-.22-2.09-.15-1.28-.33-2.57-.52-3.84-.04-.27,.14-.53,.42-.57,.28-.04,.53,.15,.57,.42,.2,1.28,.38,2.58,.53,3.87,.08,.7,.16,1.41,.23,2.11,.03,.27-.17,.52-.45,.55-.02,0-.03,0-.05,0Zm-200.6-1.53s-.04,0-.06,0c-.27-.03-.47-.28-.44-.55,.22-1.99,.5-4,.84-5.97,.05-.27,.31-.46,.58-.41,.27,.05,.46,.31,.41,.58-.34,1.95-.62,3.94-.83,5.91-.03,.26-.25,.44-.5,.44Zm199.16-8.37c-.23,0-.44-.17-.49-.4-.38-1.95-.83-3.9-1.32-5.82-.07-.27,.09-.54,.36-.61,.27-.07,.54,.09,.61,.36,.5,1.93,.95,3.91,1.34,5.88,.05,.27-.12,.53-.39,.59-.03,0-.06,0-.1,0Zm-197.56-1.51s-.07,0-.1-.01c-.27-.06-.44-.32-.38-.59,.42-1.96,.9-3.93,1.44-5.86,.07-.27,.35-.42,.62-.35,.27,.07,.42,.35,.35,.62-.53,1.91-1.01,3.87-1.42,5.81-.05,.23-.26,.4-.49,.4Zm195.15-8.19c-.21,0-.41-.14-.48-.36-.57-1.9-1.21-3.8-1.89-5.66-.1-.26,.04-.55,.3-.64s.55,.04,.64,.3c.69,1.88,1.33,3.8,1.91,5.72,.08,.26-.07,.54-.33,.62-.05,.01-.1,.02-.14,.02Zm-192.58-1.49c-.05,0-.1,0-.15-.02-.26-.08-.41-.37-.32-.63,.61-1.91,1.29-3.82,2.01-5.69,.1-.26,.39-.39,.65-.29,.26,.1,.39,.39,.29,.65-.72,1.85-1.39,3.74-1.99,5.63-.07,.21-.26,.35-.48,.35Zm189.22-7.92c-.2,0-.38-.12-.46-.31-.76-1.83-1.58-3.66-2.45-5.44-.12-.25-.02-.55,.23-.67,.25-.12,.55-.02,.67,.23,.87,1.8,1.71,3.65,2.47,5.5,.11,.25-.02,.55-.27,.65-.06,.03-.13,.04-.19,.04Zm-185.69-1.44c-.07,0-.13-.01-.2-.04-.25-.11-.37-.4-.26-.66,.8-1.83,1.66-3.67,2.57-5.46,.12-.25,.43-.35,.67-.22,.25,.12,.34,.43,.22,.67-.9,1.77-1.75,3.59-2.54,5.4-.08,.19-.27,.3-.46,.3Zm181.42-7.58c-.18,0-.35-.1-.44-.26-.93-1.74-1.94-3.48-2.97-5.16-.14-.23-.07-.54,.16-.69,.23-.15,.54-.07,.69,.16,1.05,1.7,2.06,3.46,3,5.22,.13,.24,.04,.55-.2,.68-.08,.04-.16,.06-.24,.06Zm-176.98-1.38c-.08,0-.17-.02-.24-.06-.24-.13-.33-.44-.19-.68,.98-1.75,2.02-3.49,3.09-5.18,.15-.23,.46-.3,.69-.15s.3,.46,.15,.69c-1.07,1.67-2.1,3.39-3.06,5.12-.09,.16-.26,.26-.44,.26Zm171.83-7.16c-.16,0-.32-.08-.42-.22-1.1-1.64-2.27-3.27-3.47-4.85-.17-.22-.13-.53,.09-.7,.22-.17,.53-.12,.7,.09,1.21,1.59,2.39,3.24,3.51,4.89,.15,.23,.09,.54-.14,.69-.09,.06-.18,.08-.28,.08Zm-166.54-1.32c-.1,0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7,1.14-1.64,2.35-3.27,3.59-4.84,.17-.22,.49-.25,.7-.08,.22,.17,.25,.49,.08,.7-1.22,1.56-2.42,3.17-3.55,4.8-.1,.14-.25,.21-.41,.21Zm160.56-6.68c-.14,0-.29-.06-.39-.18-1.26-1.52-2.58-3.03-3.94-4.48-.19-.2-.18-.52,.02-.71,.2-.19,.52-.18,.71,.02,1.37,1.46,2.7,2.99,3.98,4.52,.18,.21,.15,.53-.07,.7-.09,.08-.21,.11-.32,.11Zm-154.46-1.23c-.11,0-.23-.04-.32-.12-.21-.18-.24-.49-.06-.7,1.3-1.52,2.66-3.03,4.04-4.47,.19-.2,.51-.21,.71-.01,.2,.19,.21,.51,.01,.71-1.37,1.43-2.72,2.92-4,4.42-.1,.12-.24,.18-.38,.18Zm147.72-6.14c-.13,0-.25-.05-.35-.15-1.4-1.39-2.87-2.76-4.36-4.07-.21-.18-.23-.5-.05-.71,.18-.21,.5-.23,.71-.05,1.5,1.32,2.99,2.71,4.4,4.11,.2,.19,.2,.51,0,.71-.1,.1-.23,.15-.35,.15Zm-140.87-1.13c-.13,0-.26-.05-.36-.15-.19-.2-.19-.52,.01-.71,1.44-1.39,2.94-2.75,4.46-4.05,.21-.18,.53-.15,.71,.06,.18,.21,.15,.53-.06,.71-1.51,1.29-2.99,2.63-4.42,4.01-.1,.09-.22,.14-.35,.14Zm133.43-5.54c-.11,0-.22-.04-.31-.11-1.54-1.25-3.13-2.47-4.74-3.62-.22-.16-.28-.47-.11-.7,.16-.22,.47-.28,.7-.11,1.62,1.17,3.23,2.4,4.79,3.66,.21,.17,.25,.49,.07,.7-.1,.12-.24,.18-.39,.18Zm-125.9-1.02c-.15,0-.29-.07-.39-.19-.17-.22-.13-.53,.08-.7,1.57-1.23,3.19-2.44,4.84-3.58,.23-.16,.54-.1,.7,.12,.16,.23,.1,.54-.12,.7-1.63,1.13-3.24,2.33-4.79,3.55-.09,.07-.2,.11-.31,.11Zm117.84-4.89c-.09,0-.19-.03-.27-.08-1.65-1.09-3.36-2.15-5.08-3.14-.24-.14-.32-.44-.18-.68,.14-.24,.44-.32,.68-.18,1.73,1,3.46,2.07,5.13,3.17,.23,.15,.29,.46,.14,.69-.1,.15-.25,.22-.42,.22Zm-109.7-.89c-.17,0-.33-.08-.42-.23-.15-.23-.08-.54,.15-.69,1.68-1.07,3.42-2.11,5.17-3.09,.24-.13,.55-.05,.68,.19,.13,.24,.05,.55-.19,.68-1.73,.96-3.45,1.99-5.12,3.05-.08,.05-.18,.08-.27,.08Zm101.1-4.2c-.08,0-.16-.02-.23-.06-1.75-.92-3.56-1.81-5.36-2.62-.25-.11-.36-.41-.25-.66s.41-.36,.66-.25c1.82,.83,3.65,1.72,5.42,2.65,.24,.13,.34,.43,.21,.68-.09,.17-.26,.27-.44,.27Zm-92.43-.74c-.18,0-.36-.1-.45-.27-.12-.25-.03-.55,.22-.67,1.78-.9,3.62-1.76,5.46-2.56,.26-.11,.55,0,.66,.26,.11,.25,0,.55-.26,.66-1.82,.79-3.64,1.64-5.4,2.53-.07,.04-.15,.05-.23,.05Zm83.36-3.48c-.06,0-.13-.01-.19-.04-1.84-.75-3.72-1.45-5.6-2.08-.26-.09-.4-.37-.31-.63s.37-.4,.63-.31c1.9,.64,3.8,1.35,5.66,2.1,.26,.1,.38,.4,.28,.65-.08,.19-.27,.31-.46,.31Zm-74.23-.58c-.2,0-.39-.12-.47-.32-.1-.26,.03-.55,.29-.65,1.87-.72,3.78-1.39,5.69-2,.26-.08,.54,.06,.63,.32,.08,.26-.06,.54-.32,.63-1.89,.6-3.78,1.27-5.63,1.98-.06,.02-.12,.03-.18,.03Zm64.78-2.71s-.09,0-.14-.02c-1.9-.56-3.85-1.07-5.78-1.51-.27-.06-.44-.33-.38-.6,.06-.27,.33-.44,.6-.38,1.95,.45,3.92,.96,5.84,1.53,.26,.08,.42,.36,.34,.62-.06,.22-.26,.36-.48,.36Zm-55.29-.42c-.22,0-.42-.15-.48-.37-.07-.27,.08-.54,.35-.61,1.93-.53,3.9-1.01,5.86-1.43,.27-.05,.54,.12,.59,.39,.06,.27-.12,.54-.39,.59-1.94,.41-3.89,.89-5.8,1.41-.04,.01-.09,.02-.13,.02Zm45.56-1.92s-.06,0-.09,0c-1.94-.37-3.93-.68-5.9-.93-.27-.03-.47-.28-.43-.56,.04-.27,.28-.46,.56-.43,1.99,.25,3.99,.57,5.95,.94,.27,.05,.45,.31,.4,.58-.04,.24-.25,.41-.49,.41Zm-35.8-.25c-.24,0-.45-.17-.49-.42-.05-.27,.14-.53,.41-.58,1.79-.31,3.61-.57,5.42-.78l.55-.06c.28-.03,.52,.17,.55,.44s-.17,.52-.44,.55l-.54,.06c-1.79,.21-3.6,.47-5.37,.77-.03,0-.06,0-.08,0Zm25.9-1.1s-.03,0-.04,0c-1.97-.17-3.97-.28-5.96-.33-.28,0-.49-.24-.49-.51,0-.28,.28-.47,.51-.49,2.01,.05,4.03,.17,6.02,.34,.28,.02,.48,.27,.46,.54-.02,.26-.24,.46-.5,.46Zm-15.98-.1c-.26,0-.48-.2-.5-.46-.02-.28,.19-.51,.46-.53,2-.15,4.03-.23,6.02-.26h0c.27,0,.5,.22,.5,.49,0,.28-.22,.5-.49,.51-1.98,.03-3.98,.11-5.96,.26h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M378.8,175.24c-.1,0-.19-.03-.28-.08-1.66-1.11-3.31-2.29-4.9-3.52-.22-.17-.26-.48-.09-.7,.17-.22,.48-.26,.7-.09,1.57,1.21,3.21,2.38,4.85,3.48,.23,.15,.29,.46,.14,.69-.1,.14-.25,.22-.42,.22Zm-7.99-6.01c-.11,0-.23-.04-.32-.12-1.53-1.29-3.04-2.65-4.47-4.04-.2-.19-.2-.51-.01-.71,.19-.2,.51-.2,.71-.01,1.42,1.37,2.91,2.72,4.42,4,.21,.18,.24,.49,.06,.7-.1,.12-.24,.18-.38,.18Zm-7.26-6.87c-.13,0-.27-.05-.36-.16-1.38-1.46-2.72-2.98-3.99-4.52-.18-.21-.15-.53,.07-.7,.21-.18,.53-.15,.7,.07,1.26,1.53,2.58,3.03,3.95,4.47,.19,.2,.18,.52-.02,.71-.1,.09-.22,.14-.34,.14Zm-6.44-7.64c-.15,0-.3-.07-.4-.2-1.2-1.6-2.36-3.26-3.45-4.94-.15-.23-.08-.54,.15-.69,.23-.15,.54-.08,.69,.15,1.08,1.66,2.23,3.3,3.41,4.89,.17,.22,.12,.53-.1,.7-.09,.07-.2,.1-.3,.1Zm-5.53-8.32c-.17,0-.34-.09-.43-.25-1.01-1.73-1.98-3.51-2.87-5.3-.12-.25-.02-.55,.23-.67,.25-.12,.55-.02,.67,.23,.88,1.77,1.84,3.54,2.84,5.24,.14,.24,.06,.54-.18,.68-.08,.05-.17,.07-.25,.07Zm-4.55-8.89c-.19,0-.38-.11-.46-.3-.81-1.83-1.56-3.71-2.25-5.6-.09-.26,.04-.55,.3-.64,.26-.09,.55,.04,.64,.3,.67,1.86,1.42,3.72,2.22,5.53,.11,.25,0,.55-.26,.66-.07,.03-.13,.04-.2,.04Zm-3.51-9.35c-.21,0-.41-.14-.48-.35-.59-1.91-1.13-3.87-1.6-5.82-.06-.27,.1-.54,.37-.6,.27-.06,.54,.1,.6,.37,.46,1.93,.99,3.87,1.58,5.75,.08,.26-.07,.54-.33,.63-.05,.02-.1,.02-.15,.02Zm-2.43-9.69c-.24,0-.44-.17-.49-.41-.37-1.96-.69-3.97-.93-5.96-.03-.27,.16-.52,.44-.56,.27-.04,.52,.16,.56,.44,.24,1.97,.55,3.95,.92,5.89,.05,.27-.13,.53-.4,.58-.03,0-.06,0-.09,0Zm-1.32-9.91c-.26,0-.48-.2-.5-.46-.15-2-.24-4.03-.26-6.03,0-.28,.22-.5,.5-.5,.32,0,.5,.22,.5,.5,.02,1.98,.11,3.98,.26,5.96,.02,.28-.18,.52-.46,.54h-.04Zm176.19-4.76h-.01c-.28,0-.5-.23-.49-.51,.01-.62,.02-1.23,.02-1.85,0-1.37-.03-2.75-.1-4.11-.01-.28,.2-.51,.48-.52,.31,0,.51,.2,.52,.48,.06,1.38,.1,2.78,.1,4.16,0,.63,0,1.25-.02,1.88,0,.27-.23,.49-.5,.49Zm-176.4-5.23h-.02c-.28-.01-.49-.24-.48-.52,.07-2,.21-4.02,.42-6.02,.03-.27,.27-.48,.55-.45,.27,.03,.47,.27,.45,.55-.21,1.97-.34,3.97-.42,5.95,0,.27-.23,.48-.5,.48Zm176.05-4.76c-.26,0-.47-.19-.5-.45-.07-.75-.15-1.5-.24-2.26-.14-1.22-.31-2.46-.51-3.66-.04-.27,.14-.53,.42-.57,.27-.04,.53,.14,.57,.42,.19,1.22,.37,2.46,.51,3.7,.09,.76,.17,1.52,.24,2.28,.02,.27-.18,.52-.45,.54-.02,0-.03,0-.05,0Zm-175.12-5.19s-.05,0-.08,0c-.27-.04-.46-.3-.42-.57,.3-1.98,.67-3.98,1.1-5.93,.06-.27,.32-.44,.6-.38,.27,.06,.44,.33,.38,.6-.43,1.93-.8,3.9-1.09,5.86-.04,.25-.25,.43-.49,.43Zm173.66-4.69c-.23,0-.44-.16-.49-.4-.4-1.94-.87-3.89-1.4-5.8-.07-.27,.08-.54,.35-.62,.26-.07,.54,.08,.62,.35,.54,1.93,1.01,3.9,1.42,5.86,.06,.27-.12,.54-.39,.59-.03,0-.07,.01-.1,.01Zm-171.61-5.09s-.09,0-.13-.02c-.27-.07-.42-.35-.35-.61,.52-1.93,1.12-3.87,1.77-5.77,.09-.26,.37-.4,.64-.31,.26,.09,.4,.37,.31,.64-.65,1.87-1.24,3.79-1.75,5.71-.06,.22-.26,.37-.48,.37Zm169.04-4.56c-.21,0-.41-.13-.48-.34-.62-1.88-1.31-3.77-2.05-5.6-.1-.26,.02-.55,.28-.65,.26-.1,.55,.02,.65,.28,.75,1.85,1.45,3.76,2.07,5.66,.09,.26-.06,.54-.32,.63-.05,.02-.1,.02-.16,.02Zm-165.89-4.93c-.06,0-.12-.01-.18-.04-.26-.1-.38-.39-.28-.65,.74-1.86,1.55-3.72,2.42-5.53,.12-.25,.42-.35,.67-.24,.25,.12,.35,.42,.24,.67-.86,1.79-1.66,3.63-2.39,5.47-.08,.2-.27,.32-.46,.32Zm162.24-4.37c-.19,0-.37-.11-.46-.29-.82-1.8-1.72-3.59-2.67-5.32-.13-.24-.04-.55,.2-.68,.24-.13,.55-.04,.68,.2,.96,1.76,1.87,3.57,2.7,5.39,.12,.25,0,.55-.25,.66-.07,.03-.14,.05-.21,.05Zm-158.03-4.7c-.08,0-.16-.02-.24-.06-.24-.13-.34-.43-.21-.68,.94-1.77,1.96-3.52,3.02-5.22,.15-.23,.46-.3,.69-.16,.23,.15,.31,.46,.16,.69-1.05,1.68-2.06,3.42-2.99,5.16-.09,.17-.26,.26-.44,.26Zm153.36-4.12c-.17,0-.33-.09-.43-.24-1.03-1.69-2.12-3.37-3.26-4.99-.16-.23-.1-.54,.12-.7,.23-.16,.54-.1,.7,.12,1.15,1.63,2.26,3.33,3.3,5.05,.14,.24,.07,.54-.17,.69-.08,.05-.17,.07-.26,.07Zm-148.15-4.42c-.1,0-.2-.03-.28-.09-.23-.16-.28-.47-.13-.7,1.14-1.65,2.35-3.28,3.59-4.85,.17-.22,.49-.25,.7-.08,.22,.17,.25,.49,.08,.7-1.23,1.55-2.43,3.16-3.55,4.79-.1,.14-.25,.22-.41,.22Zm142.5-3.81c-.15,0-.3-.07-.4-.19-1.21-1.57-2.49-3.11-3.8-4.59-.18-.21-.16-.52,.04-.71,.21-.18,.52-.17,.71,.04,1.33,1.49,2.62,3.06,3.85,4.64,.17,.22,.13,.53-.09,.7-.09,.07-.2,.1-.31,.1Zm-136.37-4.08c-.12,0-.23-.04-.33-.12-.21-.18-.23-.5-.05-.71,1.31-1.51,2.7-2.99,4.11-4.41,.2-.2,.51-.2,.71,0,.2,.19,.2,.51,0,.71-1.4,1.4-2.77,2.87-4.07,4.36-.1,.11-.24,.17-.38,.17Zm129.83-3.47c-.13,0-.26-.05-.36-.15-1.38-1.42-2.82-2.81-4.3-4.13-.21-.18-.22-.5-.04-.71,.18-.21,.5-.22,.71-.04,1.49,1.34,2.96,2.75,4.35,4.18,.19,.2,.19,.51-.01,.71-.1,.09-.22,.14-.35,.14Zm-122.85-3.68c-.14,0-.27-.05-.37-.16-.19-.2-.17-.52,.03-.71,1.48-1.35,3.02-2.67,4.58-3.92,.22-.17,.53-.14,.7,.08s.14,.53-.08,.7c-1.55,1.23-3.07,2.54-4.53,3.87-.1,.09-.22,.13-.34,.13Zm115.5-3.08c-.11,0-.22-.04-.32-.11-1.53-1.25-3.12-2.47-4.74-3.62-.22-.16-.28-.47-.12-.7,.16-.22,.47-.28,.7-.12,1.63,1.16,3.24,2.4,4.79,3.67,.21,.18,.24,.49,.07,.7-.1,.12-.24,.18-.39,.18Zm-107.76-3.24c-.15,0-.31-.07-.4-.21-.16-.22-.11-.54,.11-.7,1.62-1.17,3.3-2.31,4.99-3.37,.23-.15,.54-.08,.69,.16,.15,.23,.08,.54-.16,.69-1.68,1.05-3.34,2.17-4.94,3.34-.09,.06-.19,.1-.29,.1Zm99.69-2.65c-.09,0-.19-.03-.27-.08-1.66-1.08-3.38-2.11-5.12-3.07-.24-.13-.33-.44-.19-.68,.13-.24,.44-.33,.68-.19,1.75,.97,3.49,2.02,5.17,3.1,.23,.15,.3,.46,.15,.69-.1,.15-.26,.23-.42,.23Zm-91.3-2.74c-.17,0-.34-.09-.44-.25-.14-.24-.05-.55,.19-.68,1.75-.99,3.54-1.92,5.34-2.78,.25-.12,.55-.01,.67,.24,.12,.25,.01,.55-.24,.67-1.78,.85-3.56,1.78-5.28,2.75-.08,.04-.16,.06-.25,.06Zm82.61-2.21c-.07,0-.15-.02-.22-.05-1.78-.88-3.61-1.72-5.43-2.47-.26-.11-.38-.4-.27-.65,.11-.26,.4-.38,.65-.27,1.85,.77,3.69,1.61,5.49,2.5,.25,.12,.35,.42,.23,.67-.09,.18-.26,.28-.45,.28Zm-73.65-2.2c-.19,0-.38-.11-.46-.31-.11-.25,.01-.55,.27-.66,1.84-.78,3.74-1.51,5.63-2.16,.26-.09,.55,.05,.64,.31,.09,.26-.05,.55-.31,.64-1.87,.65-3.74,1.36-5.57,2.14-.06,.03-.13,.04-.19,.04Zm64.46-1.73c-.06,0-.11,0-.17-.03-1.86-.68-3.77-1.3-5.68-1.84-.27-.08-.42-.35-.34-.62,.08-.27,.35-.42,.62-.34,1.93,.55,3.86,1.18,5.74,1.86,.26,.09,.39,.38,.3,.64-.07,.2-.27,.33-.47,.33Zm-55.05-1.63c-.22,0-.42-.14-.48-.36-.08-.26,.07-.54,.34-.62,1.92-.56,3.88-1.07,5.84-1.51,.27-.06,.54,.11,.6,.38,.06,.27-.11,.54-.38,.6-1.94,.43-3.88,.93-5.77,1.49-.05,.01-.09,.02-.14,.02Zm45.47-1.24s-.08,0-.12-.01c-1.92-.46-3.89-.86-5.85-1.18-.27-.05-.46-.3-.41-.58s.3-.46,.58-.41c1.98,.33,3.97,.73,5.92,1.2,.27,.06,.43,.33,.37,.6-.05,.23-.26,.38-.49,.38Zm-35.74-1.04c-.24,0-.45-.17-.49-.41-.05-.27,.13-.53,.41-.58,1.66-.29,3.36-.54,5.05-.74l.92-.1c.28-.03,.52,.17,.55,.44,.03,.27-.17,.52-.44,.55l-.91,.1c-1.67,.2-3.35,.44-5,.73-.03,0-.06,0-.09,0Zm25.89-.72s-.04,0-.06,0c-1.96-.24-3.96-.41-5.94-.51-.28-.01-.49-.25-.47-.52,.01-.28,.24-.5,.52-.47,2,.1,4.02,.28,6.01,.51,.27,.03,.47,.28,.44,.56-.03,.25-.25,.44-.5,.44Zm-15.97-.46c-.26,0-.48-.2-.5-.47-.02-.28,.19-.51,.47-.53,1.83-.11,3.69-.17,5.52-.17h.51c.28,0,.5,.23,.5,.5,0,.27-.23,.5-.5,.5h-.51c-1.81,0-3.65,.06-5.46,.17h-.03Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 427.79,
    cy: 102.41,
    r: 65.91
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M588,117.08c-4.56-17.26-20.24-30.01-38.93-30.01-7.84,0-15.14,2.28-21.33,6.15-6.9-12.32-20.06-20.66-35.18-20.66-22.26,0-40.31,18.05-40.31,40.31,0,.83,.08,1.65,.13,2.46-10.93,.2-20.49,5.97-25.97,14.6-.76,1.07-1.46,2.2-2.08,3.37l.13,.2c-1.88,4.04-2.96,8.52-2.96,13.27,0,17.38,14.09,31.46,31.46,31.46h132.81c16.92,0,30.63-13.71,30.63-30.63s-12.52-29.36-28.39-30.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M585.76,179.22h-132.81c-17.9,0-32.46-14.56-32.46-32.46,0-4.58,.96-9.03,2.86-13.26-.05-.23-.02-.47,.09-.68,.62-1.18,1.34-2.35,2.14-3.48,5.65-8.9,15.22-14.46,25.72-14.98-.03-.5-.06-1-.06-1.5,0-22.78,18.53-41.31,41.31-41.31,14.58,0,28.11,7.74,35.54,20.28,6.38-3.77,13.6-5.76,20.97-5.76,18.47,0,34.7,12.33,39.71,30.07,16.1,1.53,28.61,15.21,28.61,31.45,0,17.44-14.19,31.63-31.63,31.63Zm-160.32-45.88c.03,.19,0,.4-.08,.58-1.9,4.08-2.87,8.41-2.87,12.84,0,16.8,13.66,30.46,30.46,30.46h132.81c16.34,0,29.63-13.29,29.63-29.63,0-15.43-12.06-28.4-27.46-29.52-.43-.03-.79-.33-.89-.74-4.55-17.23-20.16-29.26-37.96-29.26-7.34,0-14.53,2.07-20.8,6-.23,.15-.51,.19-.78,.12-.27-.07-.49-.24-.62-.48-6.96-12.43-20.1-20.15-34.31-20.15-21.67,0-39.31,17.63-39.31,39.31,0,.6,.04,1.19,.08,1.77l.04,.63c.02,.27-.08,.54-.26,.74-.18,.2-.44,.32-.72,.32-10.24,.19-19.64,5.47-25.15,14.13-.68,.96-1.28,1.91-1.81,2.87Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.82,154.38c-2.76-10.45-12.25-18.17-23.57-18.17-4.75,0-9.16,1.38-12.91,3.72-4.17-7.46-12.14-12.51-21.3-12.51-13.48,0-24.4,10.93-24.4,24.4,0,.5,.05,1,.08,1.49-6.62,.12-12.4,3.61-15.72,8.84-.46,.65-.88,1.33-1.26,2.04l.08,.12c-1.14,2.44-1.79,5.16-1.79,8.03,0,10.52,8.53,19.05,19.05,19.05h80.4c10.24,0,18.54-8.3,18.54-18.54s-7.58-17.78-17.19-18.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M394.46,192.4h-80.4c-11.05,0-20.05-8.99-20.05-20.05,0-2.79,.58-5.51,1.72-8.08-.01-.18,.03-.37,.11-.54,.39-.73,.83-1.45,1.32-2.15,3.41-5.37,9.15-8.77,15.48-9.21,0-.18-.01-.36-.01-.54,0-14.01,11.4-25.4,25.4-25.4,8.84,0,17.04,4.62,21.65,12.13,3.84-2.19,8.16-3.35,12.56-3.35,11.27,0,21.18,7.46,24.35,18.23,9.82,1.07,17.41,9.46,17.41,19.41,0,10.78-8.77,19.54-19.54,19.54Zm-96.65-28.08c0,.15-.03,.29-.09,.43-1.13,2.42-1.7,4.98-1.7,7.61,0,9.95,8.1,18.05,18.05,18.05h80.4c9.67,0,17.54-7.87,17.54-17.54,0-9.14-7.14-16.81-16.26-17.48-.43-.03-.79-.33-.89-.74-2.71-10.26-12-17.42-22.6-17.42-4.37,0-8.65,1.23-12.38,3.57-.23,.15-.52,.19-.78,.12-.27-.07-.49-.24-.62-.48-4.14-7.4-11.97-12-20.43-12-12.9,0-23.4,10.5-23.4,23.4,0,.35,.02,.69,.05,1.04l.03,.39c.02,.27-.08,.54-.26,.74s-.44,.32-.72,.32c-6.07,.11-11.64,3.24-14.9,8.37-.39,.55-.72,1.08-1.02,1.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 345.6,
    cy: 190.65,
    r: 12.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.6,203.93c-7.32,0-13.28-5.96-13.28-13.28s5.96-13.28,13.28-13.28,13.28,5.96,13.28,13.28-5.96,13.28-13.28,13.28Zm0-24.56c-6.22,0-11.28,5.06-11.28,11.28s5.06,11.28,11.28,11.28,11.28-5.06,11.28-11.28-5.06-11.28-11.28-11.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M540.76,164.29c-2.6,0-5.01,.81-6.99,2.19-2.19-6.99-8.72-12.07-16.43-12.07-9.51,0-17.22,7.71-17.22,17.22s7.71,17.22,17.22,17.22h23.43c6.78,0,12.28-5.5,12.28-12.28s-5.5-12.28-12.28-12.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M540.76,189.85h-23.43c-10.05,0-18.22-8.17-18.22-18.22s8.17-18.22,18.22-18.22c7.58,0,14.24,4.6,16.96,11.56,1.97-1.1,4.18-1.68,6.46-1.68,7.32,0,13.28,5.96,13.28,13.28s-5.96,13.28-13.28,13.28Zm-23.43-34.44c-8.94,0-16.22,7.28-16.22,16.22s7.28,16.22,16.22,16.22h23.43c6.22,0,11.28-5.06,11.28-11.28s-5.06-11.28-11.28-11.28c-2.3,0-4.53,.7-6.42,2.01-.26,.18-.59,.23-.89,.12-.3-.1-.54-.34-.63-.65-2.13-6.8-8.35-11.37-15.48-11.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.8,322h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M141.51,310.72h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M787.75,377.62h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M762.03,366.34h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Zm-10,0h-6c-.28,0-.5-.22-.5-.5s.22-.5,.5-.5h6c.28,0,.5,.22,.5,.5s-.22,.5-.5,.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 665.48,
    y: 90.47,
    width: 2,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 658.05,
    y: 97.91,
    width: 16.87,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 698.12,
    y: 90.47,
    width: 2,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 690.68,
    y: 97.91,
    width: 16.87,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 722.93,
    y: 97.91,
    width: 16.87,
    height: 2,
    transform: "translate(144.28 546.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 730.37,
    y: 90.47,
    width: 2,
    height: 16.87,
    transform: "translate(144.28 546.12) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 690.49,
    y: 135.66,
    width: 16.87,
    height: 2,
    transform: "translate(108.07 534.24) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 697.93,
    y: 128.23,
    width: 2,
    height: 16.87,
    transform: "translate(108.07 534.24) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 730.56,
    y: 128.23,
    width: 2,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 723.13,
    y: 135.66,
    width: 16.87,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 762.81,
    y: 128.23,
    width: 2,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 755.38,
    y: 135.66,
    width: 16.87,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 787.71,
    y: 135.66,
    width: 16.87,
    height: 2,
    transform: "translate(136.55 602.99) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 795.15,
    y: 128.23,
    width: 2,
    height: 16.87,
    transform: "translate(136.56 603) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.61,
    y: 203.26,
    width: 2,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.18,
    y: 210.69,
    width: 16.87,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 140.18,
    y: 248.45,
    width: 16.87,
    height: 2,
    transform: "translate(-132.86 178.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.61,
    y: 241.02,
    width: 2,
    height: 16.87,
    transform: "translate(-132.86 178.15) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.54,
    y: 210.69,
    width: 16.87,
    height: 2,
    transform: "translate(-115.72 144.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 114.97,
    y: 203.26,
    width: 2,
    height: 16.87,
    transform: "translate(-115.72 144.01) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.72,
    y: 203.26,
    width: 2,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 75.29,
    y: 210.69,
    width: 16.87,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 115.17,
    y: 241.02,
    width: 2,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 107.73,
    y: 248.45,
    width: 16.87,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.53,
    y: 241.02,
    width: 2,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 75.1,
    y: 248.45,
    width: 16.87,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.84,
    y: 248.45,
    width: 16.87,
    height: 2,
    transform: "translate(-161.37 109.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.28,
    y: 241.02,
    width: 2,
    height: 16.87,
    transform: "translate(-161.37 109.32) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.95,
    y: 241.02,
    width: 2,
    height: 16.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.51,
    y: 248.45,
    width: 16.87,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 387.37,
    y: 638.97,
    width: 68.25,
    height: 9.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M457.62,650.61h-72.25v-13.64h72.25v13.64Zm-68.25-4h64.25v-5.64h-64.25v5.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 333.94,
    y: 584.23,
    width: 175.1,
    height: 11.9,
    transform: "translate(842.99 1180.37) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M509.04,596.88h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 333.94,
    y: 596.13,
    width: 175.1,
    height: 11.9,
    transform: "translate(842.99 1204.17) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M509.04,608.79h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 333.94,
    y: 608.04,
    width: 175.1,
    height: 11.9,
    transform: "translate(842.99 1227.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M509.04,620.69h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 333.94,
    y: 619.94,
    width: 175.1,
    height: 11.9,
    transform: "translate(842.99 1251.79) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M509.04,632.6h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 333.94,
    y: 631.85,
    width: 175.1,
    height: 11.9,
    transform: "translate(842.99 1275.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M509.04,644.5h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 333.94,
    y: 643.75,
    width: 175.1,
    height: 11.9,
    transform: "translate(842.99 1299.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M509.04,656.4h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 333.94,
    y: 655.65,
    width: 175.1,
    height: 11.9,
    transform: "translate(842.99 1323.21) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M509.04,668.31h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M452.1,640.97h-61.21l30.6-61.21,30.6,61.21Zm-54.74-4h48.26l-24.13-48.26-24.13,48.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 543.32,
    y: 638.97,
    width: 68.25,
    height: 9.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M613.58,650.61h-72.25v-13.64h72.25v13.64Zm-68.25-4h64.25v-5.64h-64.25v5.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 489.9,
    y: 584.23,
    width: 175.1,
    height: 11.9,
    transform: "translate(1154.9 1180.37) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M665,596.88h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 489.9,
    y: 596.13,
    width: 175.1,
    height: 11.9,
    transform: "translate(1154.9 1204.17) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M665,608.79h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 489.9,
    y: 608.04,
    width: 175.1,
    height: 11.9,
    transform: "translate(1154.9 1227.98) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M665,620.69h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 489.9,
    y: 619.94,
    width: 175.1,
    height: 11.9,
    transform: "translate(1154.9 1251.79) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M665,632.6h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 489.9,
    y: 631.85,
    width: 175.1,
    height: 11.9,
    transform: "translate(1154.9 1275.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M665,644.5h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 489.9,
    y: 643.75,
    width: 175.1,
    height: 11.9,
    transform: "translate(1154.9 1299.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M665,656.4h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 489.9,
    y: 655.65,
    width: 175.1,
    height: 11.9,
    transform: "translate(1154.9 1323.21) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M665,668.31h-175.1c-.41,0-.75-.34-.75-.75v-11.9c0-.41,.34-.75,.75-.75h175.1c.41,0,.75,.34,.75,.75v11.9c0,.41-.34,.75-.75,.75Zm-174.35-1.5h173.6v-10.4h-173.6v10.4Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M608.05,640.97h-61.21l30.6-61.21,30.6,61.21Zm-54.74-4h48.26l-24.13-48.26-24.13,48.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "702.1 461 756.55 569.9 647.65 569.9 702.1 461"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M759.78,571.9h-115.37l57.68-115.37,57.68,115.37Zm-108.9-4h102.42l-51.21-102.42-51.21,102.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M699.37,537.17l-2.05-32.2h9.55l-2.05,32.2h-5.46Zm-1.55,13.71v-7.75h8.56v7.75h-8.56Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkInsightsErrorGraphic);
export default __webpack_public_path__ + "static/media/Network Insights_Error_Graphic.628b7f64227c0209f37e0c693ef2ea17.svg";
export { ForwardRef as ReactComponent };